// pwa-install.js
(() => {
  let deferredPrompt = null;
  const BTN_ID = "pwa-install-btn";

  const ua = navigator.userAgent || "";
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (ua.includes("Macintosh") && navigator.maxTouchPoints && navigator.maxTouchPoints > 1);

  const isInStandaloneMode =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

  const btn = () => document.getElementById(BTN_ID);

  // ✅ Toujours rendre visible (sauf si déjà en mode app)
  if (!isInStandaloneMode) {
    const b = btn();
    if (b) b.style.display = "inline-flex";
  } else {
    const b = btn();
    if (b) b.style.display = "none";
    return;
  }

  // Android/Chrome: capter le prompt
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
  });

  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    const b = btn();
    if (b) b.style.display = "none";
  });

  // --- Bannière aide ---
  const removeHelp = () => document.getElementById("pwa-help")?.remove();

  const showHelp = (html) => {
    removeHelp();
    const box = document.createElement("div");
    box.id = "pwa-help";
    box.style.position = "fixed";
    box.style.left = "0";
    box.style.right = "0";
    box.style.bottom = "0";
    box.style.zIndex = "99999";
    box.style.background = "rgba(0,0,0,0.92)";
    box.style.color = "#fff";
    box.style.padding = "14px 16px";
    box.style.borderTop = "1px solid rgba(255,255,255,0.15)";
    box.style.fontSize = "14px";
    box.style.lineHeight = "1.35";
    box.innerHTML = `
      <div style="display:flex; gap:12px; align-items:flex-start;">
        <div style="font-size:20px; line-height:1;">📲</div>
        <div style="flex:1;">${html}</div>
        <button id="pwa-help-close" aria-label="Fermer"
          style="background:none;border:0;color:#fff;font-size:18px;cursor:pointer;line-height:1;">✕</button>
      </div>
    `;
    document.body.appendChild(box);
    document.getElementById("pwa-help-close")?.addEventListener("click", removeHelp);
  };

  // Click (supporte clic sur svg/span)
  document.addEventListener("click", async (e) => {
    const b = e.target?.closest?.(`#${BTN_ID}`);
    if (!b) return;

    if (isIOS) {
      showHelp(`
        <div style="font-weight:700; margin-bottom:6px;">Installer l’app sur iPhone / iPad</div>
        <ol style="margin:8px 0 0 18px; padding:0;">
          <li>Appuie sur <b>Partager</b> (⬆️)</li>
          <li>Choisis <b>Sur l’écran d’accueil</b></li>
        </ol>
      `);
      return;
    }

    if (deferredPrompt) {
      deferredPrompt.prompt();
      try {
        await deferredPrompt.userChoice;
      } finally {
        deferredPrompt = null;
      }
      return;
    }

    showHelp(`
      <div style="font-weight:700; margin-bottom:6px;">Installation</div>
      <div>Ouvre le menu (⋮) puis cherche <b>Installer l’application</b> ou <b>Ajouter à l’écran d’accueil</b>.</div>
    `);
  });
})();
